import { render, staticRenderFns } from "./portfolio-select-timeframe.component.vue?vue&type=template&id=8cdfb962"
import script from "./portfolio-select-timeframe.component.vue?vue&type=script&lang=js"
export * from "./portfolio-select-timeframe.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports